var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-button',{attrs:{"disabled":_vm.disabled,"full":"","href":"#","color":"bt-google","icon":"Google","icon-size":26,"data-testid":"google-btn"},on:{"click":_vm.logInWithGoogle}},[_vm._v("Login with Google")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }